import { useQuery } from "@tanstack/react-query";
import { CategoriesStats, getCategoriesStats } from "@/api/categoriesStats";

export enum CategoriesStatsQueryKeys {
  CategoriesStats = "categories-stats"
}

export const useCategoriesStats = () => {
  return useQuery<CategoriesStats>({
    queryKey: [CategoriesStatsQueryKeys.CategoriesStats],
    queryFn: () => getCategoriesStats()
  });
};
